import { QueryParamProvider } from 'use-query-params';
import { useReactRouter6Adapter } from '../../lib/ReactRouter6Adapter';
import { useCameras } from '../../domains/api/cameras';
import { CameraContext } from '../../domains/api/cameras/CameraContext';
import { AppLoader } from '../../domains/shared/components/AppLoader';
import { ResponsiveErrorState } from '../../domains/shared/components/ResponsiveErrorState';
import { CalculatorSelection } from '../../domains/pages/Calculators/components/CalculatorSelection';

/**
 * Embedded version of the calculators page (no header/shell).
 */
export const CalculatorsEmbedPage = () => {
  const { data: cameras, isLoading, error } = useCameras();
  const { history, location } = useReactRouter6Adapter();

  if (isLoading) {
    return <AppLoader />;
  }

  if (error || !cameras) {
    return <ResponsiveErrorState />;
  }

  return (
    <QueryParamProvider
      history={history}
      location={location as unknown as Location}
    >
      <CameraContext.Provider value={cameras}>
        <CalculatorSelection />
      </CameraContext.Provider>
    </QueryParamProvider>
  );
};
